import {
	OPEN_DATA,
	BIS,
	CITYPAY,
	COMBINED,
	FDNY_SCRAPER,
	COUNTY_CLERK,
} from 'data/dataSourceConstants';

export const tableConfig = {
	complaints311: {
		title: '311 Complaints',
		singularTitle: '311 Complaint',
		grouping: 'Complaints',
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Date', key: 'created_date', formatter: 'DateFormatter' },
				{ label: 'Description', key: 'descriptor' },
				{ label: 'Resolution', key: 'resolution_description' },
				{ label: 'Agency', key: 'agency' },
				{ label: 'Agency Name', key: 'agency_name' },
				{ label: 'Status', key: 'status', formatter: 'StatusBadge' },
			],
		},
	},

	dobComplaintsCombined: {
		title: 'DOB Complaints',
		singularTitle: 'DOB Complaint',
		dataCategory: 'violation',
		[COMBINED]: {
			columns: [
				{
					label: 'Complaint #',
					key: 'bisComplaintNumber',
					altKey: 'odComplaintNumber',
				},
				{
					label: 'Date Entered',
					key: 'bisDateEntered',
					altKey: 'odDateEntered',
					formatter: 'DateFormatter',
				},
				{
					label: 'Inspection Date',
					key: 'bisInspectionDate',
					altKey: 'odInspectionDate',
					formatter: 'DateFormatter',
				},
				{
					label: 'Disposition Date',
					key: 'bisDispositionDate',
					altKey: 'odDispositionDate',
					formatter: 'DateFormatter',
				},
				{
					label: 'Disposition',
					key: 'bisDisposition',
					altKey: 'odDisposition',
				},
				{
					label: 'Category',
					key: 'bisCategory',
					altKey: 'odCategory',
				},
				{
					label: 'Comments',
					key: 'bisComments',
					altKey: 'odComments',
				},
				{
					label: 'Status',
					key: 'status',
					formatter: 'StatusBadge',
				},
			],
		},
	},

	dobComplaints: {
		title: 'DOB Complaints',
		singularTitle: 'DOB Complaint',
		grouping: 'Complaints',
		dataCategory: 'violation',
		isHiddenFromNav: true,
		[BIS]: {
			columns: [
				{ label: 'Date', key: 'date_entered', formatter: 'DateFormatter' },
				{ label: 'Complaint #', key: 'complaint_number' },
				{ label: 'Comments', key: 'comments' },
				{ label: 'Category', key: 'category' },
				{ label: 'Status', key: 'status', formatter: 'StatusBadge' },
			],
		},
		[OPEN_DATA]: {
			columns: [
				{ label: 'Complaint #', key: 'complaint_number' },
				{
					label: 'Date Entered',
					key: 'date_entered',
					formatter: 'DateFormatter',
				},
				{
					label: 'Inspection Date',
					key: 'inspection_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'Disposition Date',
					key: 'disposition_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Disposition', key: 'disposition' },
				{ label: 'Status', key: 'status', formatter: 'StatusBadge' },
			],
		},
	},

	dobSafetyViolations: {
		title: 'DOB Violations',
		singularTitle: 'DOB Violation',
		isViolation: true,
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Resolve',
					key: 'violation_number',
					formatter: 'ResolutionRequest',
				}, // these are links
				{ label: 'Violation #', key: 'violation_number' },
				{
					label: 'Issue Date',
					key: 'violation_issue_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Violation Remarks', key: 'violation_remarks' },
				{ label: 'Violation Type', key: 'violation_type' },
				{ label: 'Device Number', key: 'device_number' },
				{
					label: 'Status',
					key: 'violation_status',
					formatter: 'StatusBadge',
				},
			],
		},
	},

	dobViolationsCombined: {
		title: 'DOB Violations (BIS)',
		singularTitle: 'DOB Violation',
		isViolation: true,
		dataCategory: 'violation',
		isAdminOnly: false,
		[COMBINED]: {
			columns: [
				{
					label: 'Resolve',
					key: 'bisViolationNumber',
					altKey: 'odViolationNumber',
					formatter: 'ResolutionRequest',
				}, // these are links
				{
					label: 'Violation #',
					key: 'bisViolationNumber',
					altKey: 'odViolationNumber',
				},
				{
					label: 'Device #',
					key: 'bisDeviceNumber',
					altKey: 'odDeviceNumber',
				},
				// { label: 'Issue Date', key: 'issue_date', formatter: 'DateFormatter' }, //missing from api
				{
					label: 'Disposition Date',
					key: 'bisDispositionDate',
					altKey: 'odDispositionDate',
					formatter: 'DateFormatter',
				},
				{
					label: 'Disposition Comments',
					key: 'bisDispositionComments',
					altKey: 'odDispositionComments',
				},
				{
					label: 'Description',
					key: 'bisViolationDescription',
					altKey: 'odViolationDescription',
				},
				{
					label: 'Violation Type',
					key: 'bisViolationType',
					altKey: 'odViolationType',
				},
				{
					label: 'Status',
					key: 'bisViolationStatus',
					altKey: 'odViolationStatus',
					formatter: 'StatusBadge',
				},
			],
		},
	},

	dobViolations: {
		title: 'DOB Violations',
		singularTitle: 'DOB Violation',
		isViolation: true,
		dataCategory: 'violation',
		isHiddenFromNav: true,
		[OPEN_DATA]: {
			columns: [
				{ label: 'Resolve', key: 'number', formatter: 'ResolutionRequest' }, // these are links
				{ label: 'Violation #', key: 'number' },
				{ label: 'Issue Date', key: 'issue_date', formatter: 'DateFormatter' },
				{
					label: 'Disposition Date',
					key: 'disposition_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Disposition Comments', key: 'disposition_comments' },
				{ label: 'Violation Type', key: 'violation_type' },
				{
					label: 'Violation Category',
					key: 'violation_category',
					formatter: 'StatusBadge',
				},
			],
		},
		[BIS]: {
			columns: [
				{
					label: 'Resolve',
					key: 'dob_violation_number',
					formatter: 'ResolutionRequest',
				}, // these are links
				{ label: 'Violation #', key: 'dob_violation_number' },
				{ label: 'Device #', key: 'device_number' },
				{ label: 'ECB Violation #', key: 'ecb_violation_number' },
				{ label: 'Description', key: 'description' },
				{ label: 'Violation Type', key: 'violation_type' },
				{ label: 'Status', key: 'status', formatter: 'StatusBadge' },
				{ label: 'File Date', key: 'file_date', formatter: 'DateFormatter' },
			],
		},
	},

	ecbViolationsCombined: {
		title: 'ECB Violations',
		singularTitle: 'ECB Violation',
		isViolation: true,
		dataCategory: 'violation',
		isAdminOnly: false,
		[COMBINED]: {
			columns: [
				{
					label: 'Resolve',
					key: 'bisEcbViolationNumber',
					altKey: 'odEcbViolationNumber',
					formatter: 'ResolutionRequest',
				},
				{
					label: 'Image',
					key: 'bisEcbViolationNumber',
					altKey: 'odEcbViolationNumber',
					formatter: 'ViolationImageLink',
				},
				{
					label: 'Status Date',
					key: 'bisStatusDate',
					altKey: 'odStatusDate',
					formatter: 'DateFormatter',
				},
				{
					label: 'ECB Violation #',
					key: 'bisEcbViolationNumber',
					altKey: 'odEcbViolationNumber',
				},
				{
					label: 'Description',
					key: 'bisViolationDescription',
					altKey: 'odViolationDescription',
				},
				{
					label: 'Hearing Date',
					key: 'bisHearingDate',
					altKey: 'odHearingDate',
					formatter: 'DateFormatter',
				},
				{
					label: 'Infra. Code',
					key: 'bisInfraCode',
					altKey: 'odInfraCode',
					formatter: 'ECBInfractionCode',
				},
				{
					label: 'Status',
					key: 'bisViolationStatus',
					altKey: 'odViolationStatus',
					formatter: 'StatusBadge',
				},
			],
		},
	},

	ecbViolations: {
		title: 'ECB Violations',
		singularTitle: 'ECB Violation',
		isViolation: true,
		dataCategory: 'violation',
		isHiddenFromNav: true,
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Resolve',
					key: 'ecb_violation_number',
					formatter: 'ResolutionRequest',
				}, // these are links
				{
					label: 'Image',
					key: 'ecb_violation_number',
					formatter: 'ViolationImageLink',
				},
				{ label: 'Date', key: 'issue_date', formatter: 'DateFormatter' },
				{
					label: 'Hearing Date',
					key: 'hearing_date',
					formatter: 'CalendarLink',
				}, //adds to google calendar
				{ label: 'ECB #', key: 'ecb_violation_number' },
				{
					label: 'Infra. Code',
					key: 'infraction_code1',
					formatter: 'ECBInfractionCode',
				},
				{ label: 'Description', key: 'violation_description' },
				{ label: 'Respondent Name', key: 'respondent_name' },
				{ label: 'Penalty Imposed', key: 'penality_imposed' },
				{
					label: 'Status',
					key: 'ecb_violation_status',
					formatter: 'StatusBadge',
				},
			],
		},
		[BIS]: {
			columns: [
				{
					label: 'Resolve',
					key: 'ecb_violation_number',
					formatter: 'ResolutionRequest',
				}, // these are links
				{
					label: 'Image',
					key: 'ecb_violation_number',
					formatter: 'ViolationImageLink',
				},
				{ label: 'ECB #', key: 'ecb_violation_number' },
				{
					label: 'Infra. Code',
					key: 'infraction_codes',
					formatter: 'ECBInfractionCode',
				},
				{
					label: 'Hearing Date/Time',
					key: 'scheduled_hearing_date',
					formatter: 'HearingDateTimeFormatter',
				},
				{
					label: 'Compliance Date',
					key: 'compliance_on',
					formatter: 'DateFormatter',
				},
				{ label: 'Penalty Imposed', key: 'penalty_imposed' },
				{
					label: 'Status',
					key: 'buildings_violation_status',
					formatter: 'StatusBadge',
				},
			],
		},
	},

	jobApplicationsCombined: {
		title: 'Work Applications',
		singularTitle: 'Work Application',
		dataCategory: 'infrastructure',
		isAdminOnly: true,
		[COMBINED]: {
			columns: [
				{
					label: 'Drawings',
					key: 'bisJobNumber',
					altKey: 'odJobNumber',
					formatter: 'ResolutionRequest',
				}, // these are links
				{
					label: 'Last Action Date',
					key: 'bisLastActionDate',
					altKey: 'odLastActionDate',
					formatter: 'DateFormatter',
				},
				{ label: 'Job #', key: 'bisJobNumber', altKey: 'odJobNumber' },
				{ label: 'Doc #', key: 'bisDocNumber', altKey: 'odDocNumber' },
				{
					label: 'Applicant Last Name',
					key: 'bisApplicantLastName',
					altKey: 'odApplicantLastName',
				},
				{ label: 'Type', key: 'bisType', altKey: 'odType' },
				{
					label: 'Status',
					key: 'bisStatus',
					altKey: 'odStatus',
					formatter: 'StatusBadge',
				}, //wrong field?
			],
		},
	},

	jobApplications: {
		title: 'Work Applications',
		singularTitle: 'Work Application',
		navTitle: 'Work Applications',
		grouping: 'Infrastructure',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Drawings', key: 'job__', formatter: 'ResolutionRequest' },
				{
					label: 'Last Action Date',
					key: 'latest_action_date_int',
					formatter: 'DateFormatter',
				},
				{ label: 'Job #', key: 'job__' },
				{ label: 'Doc #', key: 'doc__' },
				{ label: 'Type', key: 'job_type' },
				{ label: 'Desc', key: 'other_description' },
				{ label: 'Status', key: 'job_status_descrp', formatter: 'StatusBadge' },
			],
		},
		[BIS]: {
			columns: [
				{
					label: 'Drawings',
					key: 'job_number',
					formatter: 'ResolutionRequest',
				},
				{
					label: 'Last Action Date',
					key: 'status_date_int',
					formatter: 'DateFormatter',
				},
				{ label: 'Job #', key: 'job_number' },
				{ label: 'Doc #', key: 'doc_number' },
				{ label: 'Type', key: 'job_type' },
				{ label: 'Desc', key: 'job_description' },
				{ label: 'Status', key: 'job_status', formatter: 'StatusBadge' },
			],
		},
	},

	/** Pre-VWA-2564 flat table columns for side-by-side comparison with grouped view. */
	jobApplicationsLegacy: {
		title: 'Work Applications',
		singularTitle: 'Work Application',
		grouping: 'Infrastructure',
		dataCategory: 'infrastructure',
		sidebarOnly: true,
		isAdminOnly: true,
		[OPEN_DATA]: {
			columns: [
				{ label: 'Drawings', key: 'job__', formatter: 'ResolutionRequest' },
				{
					label: 'Last Action Date',
					key: 'latest_action_date_int',
					formatter: 'DateFormatter',
				},
				{ label: 'Job #', key: 'job__' },
				{ label: 'First Name', key: 'applicant_s_first_name' },
				{ label: 'Last Name', key: 'applicant_s_last_name' },
				{ label: 'Doc #', key: 'doc__' },
				{ label: 'Status', key: 'job_status_descrp', formatter: 'StatusBadge' },
			],
		},
		[BIS]: {
			columns: [
				{
					label: 'Drawings',
					key: 'job_number',
					formatter: 'ResolutionRequest',
				},
				{
					label: 'Last Action Date',
					key: 'status_date_int',
					formatter: 'DateFormatter',
				},
				{ label: 'Job #', key: 'job_number' },
				{ label: 'Doc #', key: 'doc_number' },
				{ label: 'Type', key: 'job_type' },
				{ label: 'Applicant', key: 'applicant' },
				{ label: 'Status', key: 'job_status', formatter: 'StatusBadge' },
			],
		},
	},
	dobJobApplications: {
		// title: 'DOB NOW Build - Job Application Filings',
		title: 'Work Applications (DOB Now)',
		// singularTitle: 'DOB NOW Build - Job Application Filing',
		singularTitle: 'Work Application (DOB Now)',
		// navTitle: 'Job Application Filings',
		navTitle: 'Work Applications (DOB Now)',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Drawings',
					key: 'job_filing_number',
					formatter: 'ResolutionRequest',
				},
				{
					label: 'Filing Status Date',
					key: 'filing_status_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Job #', key: 'job_number' },
				{ label: 'Business Name', key: 'owner_s_business_name' },
				{ label: 'Filing #', key: 'filing_designation' },
				{ label: 'Job Type', key: 'job_type' },
				{ label: 'Work Type', key: 'work_type' },
				{ label: 'Work on Floor(s)', key: 'work_on_floor' },
				{
					label: 'Filing Status',
					key: 'filing_status',
					formatter: 'StatusBadge',
				},
			],
		},
	},
	// dobJobApplications: {
	// 	// title: 'DOB NOW Build - Job Application Filings',
	// 	title: 'DOB NOW Build - Work Application Filings',
	// 	// singularTitle: 'DOB NOW Build - Job Application Filing',
	// 	singularTitle: 'DOB NOW Build - Work Application Filings',
	// 	// navTitle: 'Job Application Filings',
	// 	navTitle: 'Work Applications (DOB Now)',
	// 	// grouping: 'Department of Buildings',
	// 	grouping: 'Job Applications',
	// 	dataCategory: 'infrastructure',
	// 	[OPEN_DATA]: {
	// 		columns: [
	// 			{ label: 'Job Filing #', key: 'job_filing_number' },
	// 			{ label: 'Filing Status', key: 'filing_status' },
	// 			{ label: 'Business Name', key: 'owner_s_business_name' },
	// 		],
	// 	},
	// },

	dobPermitIssuances: {
		title: 'DOB Permit Issuances',
		singularTitle: 'DOB Permit Issuance',
		navTitle: 'Permit Issuances',
		// grouping: 'Department of Buildings',
		grouping: 'Job Applications',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Issue Date',
					key: 'issuance_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'Expiration Date',
					key: 'expiration_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Job #', key: 'job__' },
				{ label: 'Job Doc', key: 'job_doc___' },
				{ label: 'Permittee First Name', key: 'permittee_s_first_name' },
				{ label: 'Permittee Last Name', key: 'permittee_s_last_name' },
				{ label: 'Permittee Business', key: 'permittee_s_business_name' },
				{ label: 'Permittee Phone', key: 'permittee_s_phone__' },
				{ label: 'License Type', key: 'permittee_s_license_type' },
				{ label: 'License', key: 'permittee_s_license__' },
				{ label: 'Filing Status', key: 'filing_status' },
				{
					label: 'Permit Status',
					key: 'permit_status',
					formatter: 'StatusBadge',
				},
			],
		},
	},
	approvedPermits: {
		title: 'DOB NOW Build - Approved Permits',
		singularTitle: 'DOB NOW Build - Approved Permit',
		navTitle: 'Approved Permits',
		// grouping: 'Department of Buildings',
		grouping: 'Job Applications',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'View Permit',
					key: 'work_permit_print_urls',
					formatter: 'WorkPermitPrintLinks',
				},
				{ label: 'Job Filing #', key: 'job_filing_number' },
				{ label: 'Work Permit', key: 'work_permit' },
				{
					label: 'Status',
					key: 'permit_status',
					formatter: 'StatusBadge',
				},
				{
					label: 'Issued Date',
					key: 'issued_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'Expiring Date',
					key: 'expired_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Floor', key: 'work_on_floor' },
				{ label: 'Work Type', key: 'work_type' },
				{ label: 'Description', key: 'job_description' },
				{ label: 'First Name', key: 'applicant_first_name' },
				{ label: 'Last Name', key: 'applicant_last_name' },
				{ label: 'Applicant Business', key: 'applicant_business_name' },
				{ label: 'Applicant Address', key: 'applicant_business_address' },
				{ label: 'Estimated Costs', key: 'estimated_job_costs' },
			],
		},
	},
	certificatesOfOccupancy: {
		title: 'DOB Certificates of Occupancy',
		singularTitle: 'DOB Certificate of Occupancy',
		navTitle: 'Certificates of Occupancy',
		// grouping: 'Department of Buildings',
		grouping: 'Infrastructure',
		dataCategory: 'certification',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Issues Date',
					key: 'c_o_issue_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'Job #',
					key: 'job_number',
					formatter: 'WorkAppJobNumberLink',
				},
				{ label: 'Source', key: 'source' },
				{ label: 'Issue Type', key: 'issue_type' },
				{ label: 'Filing Status', key: 'filing_status_raw' },
				{ label: 'Work App', key: 'job_number', formatter: 'WorkAppLink' },
			],
		},
	},
	dobNowSafetyFacades: {
		title: 'Facade Filings',
		singularTitle: 'Facade Filing',
		grouping: 'Job Applications',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Job Filing #', key: 'tr6_no' },
				{ label: 'Control #', key: 'control_no' },
				{ label: 'Filing Type', key: 'filing_type' },
				{ label: 'Filing Status', key: 'filing_status' },
				{ label: 'Current Status', key: 'current_status' },
				{ label: 'Prior Status', key: 'prior_status' },
				{ label: 'QEWI Name', key: 'qewi_name' },
				{ label: 'QEWI Address', key: 'qewi_bus_street_name' },
				{
					label: 'Field Inspection Date',
					key: 'field_inspection_completed_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'QEWI Signed Date',
					key: 'qewi_signed_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'Submitted Date',
					key: 'submitted_on',
					formatter: 'DateFormatter',
				},
				{ label: 'Late Filing Amount', key: 'late_filing_amt' },
				{ label: 'Failure to File Amount', key: 'failure_to_file_amt' },
				{ label: 'Failure to Collect Amount', key: 'failure_to_collect_amt' },
			],
		},
	},
	// dobSignApplicationFilings — old Open Data Signage dataset (commented out, replaced by BIS illuminated signs)
	// dobSignApplicationFilings: {
	// 	title: 'Signage',
	// 	singularTitle: 'Signage',
	// 	dataCategory: 'infrastructure',
	// 	[OPEN_DATA]: {
	// 		columns: [
	// 			{ label: 'Job #', key: 'job__' },
	// 			{ label: 'Job Status', key: 'job_status' },
	// 			{ label: 'Filing Date', key: 'pre_filing_date', formatter: 'DateFormatter' },
	// 		],
	// 	},
	// },
	bisIlluminatedSigns: {
		title: 'Illuminated Signs',
		singularTitle: 'Illuminated Sign',
		dataCategory: 'infrastructure',
		[BIS]: {
			columns: [
				{ label: 'SEQ', key: 'seq_no' },
				{ label: 'Job #', key: 'job_number' },
				{ label: 'Sq Ft', key: 'square_footage' },
				{ label: 'Sign Wording', key: 'sign_wording' },
				{
					label: 'Expiration Date',
					key: 'expires',
					formatter: 'DateFormatter',
				},
			],
		},
	},
	dobNowSafetyBoilers: {
		title: 'Boilers Safety (DOB Now)',
		singularTitle: 'Boiler',
		// grouping: 'Department of Buildings',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Boiler ID', key: 'boiler_id' },
				{ label: 'Report Type', key: 'report_type' },
				{ label: 'First Name', key: 'applicantfirst_name' },
				{ label: 'Last Name', key: 'applicant_last_name' },
				{ label: 'License Type', key: 'applicant_license_type' },
				{ label: 'License #', key: 'applicant_license_number' },
				{
					label: 'Inspection Date',
					key: 'inspection_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Report Status', key: 'report_status' },
			],
		},
	},
	bisBoilers: {
		title: 'Boilers (BIS)',
		singularTitle: 'Boiler',
		dataCategory: 'infrastructure',
		[BIS]: {
			columns: [
				{ label: 'Viol', key: 'viol' },
				{ label: 'Num', key: 'num', formatter: 'BisBoilerNumLink' },
				{ label: 'MD', key: 'md' },
				{ label: 'Ser#', key: 'serial_number' },
				{ label: 'Status', key: 'status' },
				{
					label: 'Insp Date',
					key: 'last_insp_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'Recv Date',
					key: 'last_recv_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Name', key: 'name' },
			],
		},
	},
	electricalPermitApplications: {
		title: 'Electrical Permit Applications (DOB Now)',
		singularTitle: 'Electrical',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Job Number', key: 'job_number' },
				{ label: 'Filing #', key: 'filing_number' },
				{
					label: 'Filing Date',
					key: 'filing_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'Applicant @ Firm',
					key: 'applicant_last_name',
					altKey: 'firm_name',
					formatter: 'ApplicantAtFirm',
				},
				{ label: 'Filing Type', key: 'filing_type' },
				{
					label: 'Job Description',
					key: 'job_description',
					formatter: 'TruncatedText',
				},
				{
					label: 'Amount Due',
					key: 'amount_due',
					formatter: 'CurrencyAmount',
				},
				{
					label: 'Filing Status',
					key: 'filing_status',
					formatter: 'ElectricalFilingStatusBadge',
				},
			],
		},
	},
	elevatorPermitApplications: {
		title: 'Elevators Permit Application (DOB Now)',
		singularTitle: 'Elevator',
		// grouping: 'Department of Buildings',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Job Filing Number', key: 'job_filing_number' },
				{ label: 'Job Number', key: 'job_number' },
				{
					label: 'Filing Date',
					key: 'filing_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Filing Type', key: 'filing_type' },
				{ label: 'Filing Status', key: 'filing_status' },
			],
		},
	},
	elevatorRecords: {
		title: 'Elevator Records (BIS)',
		singularTitle: 'Elevator Record',
		dataCategory: 'infrastructure',
		[BIS]: {
			columns: [
				{
					label: 'Resolve',
					key: 'device_number',
					formatter: 'ResolutionRequest',
				},
				{ label: 'Device Number', key: 'device_number' },
				{ label: 'Status', key: 'device_status' },
				{ label: 'Device Type', key: 'device_type' },
				{
					label: 'Status Date',
					key: 'status_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Floor From', key: 'floor_from' },
				{ label: 'Floor To', key: 'floor_to' },
			],
		},
	},
	limitedAlterationApplications: {
		title: 'Limited Alteration Application (DOB Now)',
		singularTitle: 'Limited Alteration Application',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Drawings',
					key: 'job_number',
					formatter: 'ResolutionRequest',
				},
				{ label: 'Job #', key: 'job_number' },
				{ label: 'Filing #', key: 'filing_number' },
				{
					label: 'Filing Date',
					key: 'filing_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'Permit Expiration Date',
					key: 'permit_expiration_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Filing Type', key: 'filing_type_name' },
				{ label: 'Work Type', key: 'work_type_name' },
				{ label: 'Proposed Work Summary', key: 'proposed_work_summary' },
				{
					label: 'Filing Status',
					key: 'filing_status_name',
					formatter: 'StatusBadge',
				},
			],
		},
	},
	hpdHousingViolations: {
		title: 'Housing Violations',
		singularTitle: 'Housing Violation',
		grouping: 'HPD',
		isViolation: true,
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Resolve',
					key: 'violationid',
					formatter: 'ResolutionRequest',
				}, // these are links
				{ label: 'Violation ID', key: 'violationid' },
				{
					label: 'Issue Date',
					key: 'novissueddate',
					formatter: 'DateFormatter',
				},
				{ label: 'Description', key: 'novdescription' },
				{ label: 'Status', key: 'currentstatus', formatter: 'StatusBadge' },
			],
		},
	},

	housingLitigations: {
		title: 'Housing Litigations',
		singularTitle: 'Housing Litigation',
		grouping: 'HPD',
		isViolation: true,
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Resolve',
					key: 'litigationid',
					formatter: 'ResolutionRequest',
				},
				{ label: 'Id', key: 'litigationid' },
				{ label: 'Case Type', key: 'casetype' },
				{
					label: 'Case Open Date',
					key: 'caseopendate',
					formatter: 'DateFormatter',
				},
				{ label: 'Open Judgement', key: 'casejudgement' },
				{ label: 'Penalty', key: 'penalty' },
				{
					label: 'CaseStatus',
					key: 'casestatus_label',
					formatter: 'StatusBadge',
				},
			],
		},
	},

	sideWalkViolations: {
		title: 'Sidewalk Violations',
		singularTitle: 'Sidewalk Violations',
		navTitle: 'Sidewalk Violations',
		isViolation: true,
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Violation ID', key: 'violationid' },
				{ label: 'Sidewalk Violation #', key: 'swv_number' },
				{
					label: 'Violation Date',
					key: 'vissuedate',
					formatter: 'DateFormatter',
				},
				{
					label: 'Resolved Date',
					key: 'certi_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Grace Period', key: 'grace_pd' },
				{ label: 'Square Feet', key: 'sq_feet' },
				{ label: 'Status', key: 'status', formatter: 'StatusBadge' },
			],
		},
	},
	// DOT Liens (VWA-2696): sidewalk liens from the NY County Clerk / JDLS index.
	// status is the clerk-derived Open / Released value; StatusBadge colors it
	// from the row's isOpen flag, which is what the ticket's "current vs
	// released" indicator maps to. amount is the parsed decimal (amount_raw, the
	// source's own money string, stays available on the detail view).
	dotLiens: {
		title: 'DOT Liens',
		singularTitle: 'DOT Lien',
		navTitle: 'DOT Liens',
		isViolation: true,
		dataCategory: 'violation',
		[COUNTY_CLERK]: {
			columns: [
				{ label: 'Control Number', key: 'control_number' },
				{ label: 'Index Number', key: 'index_number' },
				{ label: 'Debtor Name', key: 'debtor_name' },
				{ label: 'Creditor Name', key: 'creditor_name' },
				{ label: 'Book', key: 'book' },
				{
					label: 'Docket Date',
					key: 'docket_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Debtor Address', key: 'debtor_address' },
			],
		},
	},

	// hpdHousingComplaints: {
	// 	title: 'Housing Complaints',
	// 	singularTitle: 'Housing Complaint',
	// 	grouping: 'HPD',
	// 	dataCategory: 'violation',
	// 	[OPEN_DATA]: {
	// 		columns: [
	// 			{ label: 'Complaint ID', key: 'complaintid' },
	// 			{ label: 'Date', key: 'receiveddate', formatter: 'DateFormatter' },
	// 			{ label: 'Problems', key: 'statusdescription' }, //todo: this has a custom renderer in legacy vue
	// 			{ label: 'Status', key: 'status', formatter: 'StatusBadge' },
	// 		],
	// 	},
	// },
	hpdComplaints: {
		title: 'Housing Complaints',
		singularTitle: 'Housing Complaint',
		grouping: 'HPD',
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Complaint ID', key: 'complaint_id' },
				{ label: 'Date', key: 'received_date', formatter: 'DateFormatter' },
				// { label: 'Type', key: 'type' },
				{ label: 'Apt #', key: 'apartment' },
				{ label: 'Category', key: 'major_category' },
				{ label: 'Condition', key: 'minor_category' },
				{ label: 'Detail', key: 'problem_code' },
				{ label: 'Location', key: 'space_type' },
				// { label: 'Description', key: 'status_description' },
				{ label: 'Status', key: 'complaint_status', formatter: 'StatusBadge' },
			],
		},
	},
	repairVacateOrders: {
		title: 'HPD Orders to Repair/Vacate',
		singularTitle: 'HPD Order to Repair/Vacate',
		navTitle: 'Orders to Repair/Vacate',
		grouping: 'HPD',
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Resolve',
					key: 'vacate_order_number',
					formatter: 'ResolutionRequest',
				}, // these are links
				{ label: 'Order Number', key: 'vacate_order_number' },
				{
					label: 'Date',
					key: 'vacate_effective_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Type', key: 'vacate_type' },
				{ label: 'Reason', key: 'primary_vacate_reason' },
				{ label: 'Units Vacated', key: 'number_of_vacated_units' },
			],
		},
	},
	stopWorkOrders: {
		title: 'Stop Work Orders',
		singularTitle: 'Stop Work Order',
		navTitle: 'Stop Work Orders',
		grouping: 'complaints',
		dataCategory: 'violation',
		[BIS]: {
			columns: [
				{
					label: 'Resolve',
					key: 'complaint_number',
					formatter: 'ResolutionRequest',
				}, // these are links
				{ label: 'Order Number', key: 'complaint_number' },
				{ label: 'Date', key: 'date_entered', formatter: 'DateFormatter' },
				{ label: 'Type', key: 'category' },
				{ label: 'Reason', key: 'reason' },
				{ label: 'Units Vacated', key: '' },
			],
		},
	},
	standardsApplicationStatuses: {
		title: 'Board of Standards and Appeals',
		singularTitle: 'Board of Standards and Appeals',
		dataCategory: 'certification',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Date Filed', key: 'filed', formatter: 'DateFormatter' },
				{ label: 'Status', key: 'status' },
				{ label: 'Project Description', key: 'project_description' },
			],
		},
	},
	fdnyNov: {
		title: 'FDNY Notice of Violation',
		singularTitle: 'FDNY Notice of Violation',
		navTitle: 'FDNY Notice of Violation',
		grouping: 'FDNY',
		isViolation: true,
		dataCategory: 'violation',
		[FDNY_SCRAPER]: {
			columns: [
				{ label: 'Resolve', key: 'summons', formatter: 'ResolutionRequest' },
				{ label: 'Image', key: 'summons', formatter: 'ViolationImageLink' },
				{ label: 'Summons #', key: 'summons' },
				{
					label: 'Summons Date',
					key: 'summons_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'Hearing Date',
					key: 'hearing_date',
					formatter: 'DateFormatter',
					format: 'MMM D, YYYY',
				},
				{ label: 'Fines', key: 'fines', formatter: 'OutstandingFees' },
				{ label: 'Owner', key: 'owner_name' },
				{ label: 'Violations', key: 'violations' },
				{ label: 'Status', key: 'status', formatter: 'StatusBadge' },
			],
		},
	},
	fdnyVio: {
		title: 'FDNY Vio Orders',
		singularTitle: 'FDNY Vio Order',
		navTitle: 'FDNY Vio Orders',
		grouping: 'FDNY',
		isViolation: true,
		dataCategory: 'violation',
		[FDNY_SCRAPER]: {
			columns: [
				{
					label: 'Resolve',
					key: 'order_number',
					formatter: 'ResolutionRequest',
				},
				{ label: 'Order #', key: 'order_number' },
				{
					label: 'Violation Date',
					key: 'violation_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Violation', key: 'violation' },
				{ label: 'Status', key: 'status', formatter: 'StatusBadge' },
			],
		},
	},
	// Source 2 of OATH/ECB Hearings (VWA-2773): reached through that dataset's
	// Resources dropdown rather than its own sidebar link, so it carries the
	// same title and the same columns the ticket specifies for all three views.
	fdnyOathHearings: {
		title: 'OATH Hearings',
		singularTitle: 'OATH Hearing',
		navTitle: 'OATH Hearings',
		grouping: 'FDNY',
		isViolation: true,
		dataCategory: 'violation',
		isHiddenFromNav: true,
		[OPEN_DATA]: {
			columns: [
				{ label: 'Resolve', key: 'ticket_number', formatter: 'ResolutionRequest' },
				{ label: 'View Image', key: 'ticket_number', formatter: 'ViolationImageLink' },
				{ label: 'Summons/Notice No', key: 'ticket_number' },
				{ label: 'Respondent Name', key: 'respondent_last_name' },
				{ label: 'Issuing Agency', key: 'issuing_agency' },
				{
					label: 'Date Issued',
					key: 'violation_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Balance Due', key: 'balance_due' },
				{ label: 'Hearing Result', key: 'hearing_result' },
				{
					label: 'Hearing Date',
					key: 'hearing_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Status', key: 'hearing_status', formatter: 'StatusBadge' },
			],
		},
	},
	oathHearingsCombined: {
		title: 'OATH Hearings',
		singularTitle: 'OATH Hearing',
		navTitle: 'OATH Hearings',
		grouping: 'FDNY',
		isViolation: true,
		dataCategory: 'violation',
		[COMBINED]: {
			columns: [
				{
					label: 'Resolve',
					key: 'etfViolationNo',
					altKey: 'odTicketNumber',
					formatter: 'ResolutionRequest',
				},
				{
					label: 'View Image',
					key: 'etfViolationNo',
					altKey: 'odTicketNumber',
					formatter: 'ViolationImageLink',
				},
				{
					label: 'Summons/Notice No',
					key: 'etfViolationNo',
					altKey: 'odTicketNumber',
				},
				{
					label: 'Respondent Name',
					key: 'etfRespondentName',
					altKey: 'odRespondentName',
				},
				{
					label: 'Issuing Agency',
					key: 'etfIssuingAgency',
					altKey: 'odIssuingAgency',
				},
				{
					label: 'Date Issued',
					key: 'etfDateIssued',
					altKey: 'odDateIssued',
					formatter: 'DateFormatter',
				},
				{
					label: 'Balance Due',
					key: 'etfBalanceDue',
					altKey: 'odBalanceDue',
				},
				{
					label: 'Hearing Result',
					key: 'etfHearingResult',
					altKey: 'odHearingResult',
				},
				{
					label: 'Hearing Date',
					key: 'etfHearingDate',
					altKey: 'odHearingDate',
					formatter: 'DateFormatter',
				},
				{
					label: 'Status',
					key: 'etfStatus',
					altKey: 'odHearingStatus',
					formatter: 'StatusBadge',
				},
			],
		},
	},
	ecbTicketFinderHearings: {
		title: 'OATH Hearings',
		singularTitle: 'OATH Hearing',
		navTitle: 'OATH Hearings',
		grouping: 'FDNY',
		isViolation: true,
		dataCategory: 'violation',
		isHiddenFromNav: true,
		[OPEN_DATA]: {
			columns: [
				{ label: 'Resolve', key: 'violation_no', formatter: 'ResolutionRequest' },
				{ label: 'View Image', key: 'violation_no', formatter: 'ViolationImageLink' },
				{ label: 'Summons/Notice No', key: 'violation_no' },
				{ label: 'Respondent Name', key: 'respondent_name' },
				{ label: 'Issuing Agency', key: 'issuing_agency' },
				{ label: 'Date Issued', key: 'date_issued', formatter: 'DateFormatter' },
				{ label: 'Balance Due', key: 'balance_due' },
				{ label: 'Hearing Result', key: 'hearing_result' },
				{ label: 'Hearing Date', key: 'hearing_date', formatter: 'DateFormatter' },
				{ label: 'Status', key: 'status', formatter: 'StatusBadge' },
			],
		},
	},
	fdnyViolations: {
		title: 'FDNY Violations (Old)',
		singularTitle: 'FDNY Violation',
		navTitle: 'FDNY Violations (Old)',
		grouping: 'FDNY',
		isViolation: true,
		isArchived: true,
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Resolve',
					key: 'violation_num',
					formatter: 'ResolutionRequest',
				}, // these are links
				{ label: 'Date', key: 'vio_date', formatter: 'DateFormatter' },
				{ label: 'Violation ID', key: 'vio_id' },
				{ label: 'Violation Number', key: 'violation_num' },
				{ label: 'Description', key: 'vio_law_desc' },
				{ label: 'Status', key: 'action', formatter: 'StatusBadge' },
			],
		},
	},
	fdnyInspections: {
		title: 'FDNY Inspections',
		singularTitle: 'FDNY Inspection',
		navTitle: 'FDNY Inspections',
		grouping: 'FDNY',
		isArchived: true,
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Date', key: 'last_visit_dt', formatter: 'DateFormatter' },
				{ label: 'Acct ID', key: 'acct_id' },
				{ label: 'Owner Name', key: 'owner_name' },
				{ label: 'Status', key: 'last_insp_stat', formatter: 'StatusBadge' },
			],
		},
	},
	// fdnyPermits: {
	// 	title: 'FDNY Permits',
	// 	singularTitle: 'FDNY Permit',
	// 	navTitle: 'FDNY Permits',
	// 	grouping: 'FDNY',
	// 	isViolation: true,
	// 	// isArchived: true,
	// 	dataCategory: 'violation',
	// 	[NYC_GOV]: {
	// 		columns: [
	// 			{ label: 'Resolve', key: 'entityId', formatter: 'ResolutionRequest' }, // these are links
	// 			{ label: 'Date', key: 'displayStatusDate', formatter: 'DateFormatter' },
	// 			{ label: 'Type', key: 'statusAgencyOrType' },
	// 			{ label: 'Account #', key: 'entityId' },
	// 			// { label: 'Category', key: 'statusCategory' },
	// 			{ label: 'PDF', key: 'pdfLink', formatter: 'OutboundLink' },
	// 			{ label: 'Status', key: 'statusCode', formatter: 'StatusBadge' },
	// 		],
	// 	},
	// },
	fdnyPermits2: {
		title: 'FDNY Permits',
		singularTitle: 'FDNY Permit',
		navTitle: 'FDNY Permits',
		grouping: 'FDNY',
		isViolation: true,
		dataCategory: 'violation',
		[FDNY_SCRAPER]: {
			columns: [
				{ label: 'Resolve', key: 'id', formatter: 'ResolutionRequest' },
				{ label: 'Acct #', key: 'account_number' },
				{ label: 'Record Status', key: 'record_status' },
				{
					label: 'Expiration Date',
					key: 'expiration_date',
					formatter: 'DateFormatter',
				},
				{
					label: 'Outstanding Fees',
					key: 'outstanding_fee_amount',
					formatter: 'OutstandingFees',
				},
				{ label: 'Owner Name', key: 'owner_name' },
				{
					label: 'Last Insp Date',
					key: 'last_insp_date',
					formatter: 'DateFormatter',
				},
			],
		},
	},
	fdnySummaries: {
		navTitle: 'FDNY Summary',
		title: 'FDNY - Summary',
		singularTitle: 'FDNY - Summary',
		grouping: 'FDNY',
		isArchived: true,
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Summary Id', key: 'summary_id' },
				{ label: '# Siam Sprinklers', key: 'num_siam_sprinkler' },
				{ label: 'Sprinkler Type', key: 'sprinkler_type' },
				{ label: '# Siam Standpipes', key: 'num_siam_standpipe' },
				{ label: 'Standpipe Type', key: 'standpipe_type' },
				{ label: '# Open Notices of Violation', key: 'num_of_violation' },
				{ label: '# Open Violation Orders', key: 'num_of_violation_1' },
			],
		},
	},
	citypayTickets: {
		title: 'CityPay Tickets',
		singularTitle: 'CityPay Ticket',
		dataCategory: 'violation',
		isViolation: true,
		[CITYPAY]: {
			columns: [
				{
					label: 'Resolve',
					key: 'ticketNumber',
					formatter: 'ResolutionRequest',
				}, // these are links
				{
					label: 'Vio. Date',
					key: 'violationDate',
					formatter: 'DateFormatter',
				},
				{ label: 'Ticket Number', key: 'ticketNumber' },
				{ label: 'Description', key: 'description' },
				{ label: 'Issuing Agency', key: 'issuingAgency' },
				{ label: 'Status', key: 'status' },
				{ label: 'Total Due', key: 'totalAmountDue' },
			],
		},
	},
	taxLienSales: {
		title: 'Tax Lien Sales',
		singularTitle: 'Tax Lien Sale',
		dataCategory: 'certification',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Date', key: 'month', formatter: 'DateFormatter' },
				{ label: 'Cycle', key: 'cycle' },
				{ label: 'Tax Class Code', key: 'tax_class_code' },
				{ label: 'Building Class', key: 'building_class' },
				{ label: 'Community Board', key: 'community_board' },
				{ label: 'Council District', key: 'council_district' },
			],
		},
	},
	acrisLegals: {
		title: 'ACRIS Legals',
		singularTitle: 'ACRIS Real Property Legal',
		dataCategory: 'certification',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Document ID',
					key: 'document_id',
					formatter: 'AcrisRealPropertyMaster',
				},
				{ label: 'Record Type', key: 'record_type' },
				{ label: 'Easement', key: 'easement' },
				{ label: 'Partial Lot', key: 'partial_lot' },
				{ label: 'Air Rights', key: 'air_rights' },
				{ label: 'Subterranean Rights', key: 'subterranean_rights' },
				{ label: 'Property Type', key: 'property_type' },
				{
					label: 'Good Through Date',
					key: 'good_through_date',
					formatter: 'DateFormatter',
				},
			],
		},
	},
	acrisDocuments: {
		title: 'ACRIS Documents',
		singularTitle: 'ACRIS Document',
		dataCategory: 'certification',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Resolve',
					key: 'document_id',
					formatter: 'ResolutionRequest',
				},
				{
					label: 'Image',
					key: 'image_url',
					formatter: 'AcrisImageLink',
				},
				{
					label: 'Detail',
					key: 'detail_url',
					formatter: 'AcrisDetailLink',
				},
				{ label: 'Record Type', key: 'record_type' },
				{
					label: 'Date Recorded',
					key: 'recorded_date',
					formatter: 'DateFormatter',
					format: 'MMM D, YYYY',
				},
				{
					label: 'Lot/Unit',
					key: 'lots',
					altKey: 'units',
					formatter: 'AcrisLotUnit',
				},
				{ label: 'Doc ID', key: 'document_id' },
				{
					label: 'Grantor / Seller / Borrower',
					key: 'grantors',
					formatter: 'AcrisParty',
				},
				{
					label: 'Grantee / Buyer / Lender',
					key: 'grantees',
					formatter: 'AcrisParty',
				},
			],
		},
	},
	acrisSalesTransfers: {
		title: 'ACRIS Sales and Transfers',
		singularTitle: 'ACRIS Sale or Transfer',
		dataCategory: 'certification',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Resolve',
					key: 'document_id',
					formatter: 'ResolutionRequest',
				},
				{
					label: 'Image',
					key: 'image_url',
					formatter: 'AcrisImageLink',
				},
				{
					label: 'Detail',
					key: 'detail_url',
					formatter: 'AcrisDetailLink',
				},
				{
					label: 'Date Recorded',
					key: 'recorded_date',
					formatter: 'DateFormatter',
					format: 'MMM D, YYYY',
				},
				{ label: 'Doc. Type', key: 'doc_type' },
				{
					label: 'Lot/Unit',
					key: 'lots',
					altKey: 'units',
					formatter: 'AcrisLotUnit',
				},
				{
					label: 'Amount',
					key: 'amount',
					formatter: 'CurrencyAmount',
				},
				{
					label: '% Transfer',
					key: 'percent_transfer',
					formatter: 'AcrisPercentTransfer',
				},
				{
					label: 'From (Seller)',
					key: 'grantors',
					formatter: 'AcrisParty',
				},
				{
					label: 'To (Buyer)',
					key: 'grantees',
					formatter: 'AcrisParty',
				},
			],
		},
	},
	dobPlaceOfAssembly: {
		title: 'DOB Place of Assembly',
		singularTitle: 'DOB Place of Assembly',
		dataCategory: 'certification',
		[BIS]: {
			columns: [
				{ label: 'Job #', key: 'jobNumber' },
				{ label: 'File Date', key: 'fileDate', formatter: 'DateFormatter' },
				{ label: 'License Number', key: 'licenseNumber' },
				{ label: 'Applicant', key: 'applicant' },
				{ label: 'Description', key: 'description' },
				{ label: 'PDF', key: 'pdfLink', formatter: 'OutboundLink' },
				{ label: 'Details', key: 'detailsLink', formatter: 'OutboundLink' },
				{ label: 'Job Status', key: 'jobStatus', formatter: 'StatusBadge' },
			],
		},
	},
	slaLiquorLicenses: {
		title: 'SLA Liquor Licenses',
		singularTitle: 'SLA Liquor License',
		dataCategory: 'certification',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Legal Name', key: 'legalname' },
				{ label: 'Premises', key: 'actualaddressofpremises' },
				{ label: 'Description', key: 'description' },
				{ label: 'Issued', key: 'lastissuedate', formatter: 'DateFormatter' },
				{
					label: 'Effective',
					key: 'effectivedate',
					formatter: 'DateFormatter',
				},
				{ label: 'Expires', key: 'expirationdate', formatter: 'DateFormatter' },
				{ label: 'Class', key: 'class' },
				{ label: 'Type', key: 'type' },
				{ label: 'Permit ID', key: 'licensepermitid' },
				{ label: 'Legacy Serial #', key: 'legacyserialnumber' },
			],
		},
	},
	// dosBusinessEntities: {
	// 	title: 'DOS Business Entities',
	// 	singularTitle: 'DOS Business Entity',
	// 	dataCategory: 'certification',
	// 	[OPEN_DATA]: {
	// 		columns: [
	// 			{ label: 'Name', key: 'corp_name' },
	// 			{ label: 'Id', key: 'corpid_num' },
	// 			{ label: 'Doc Type', key: 'documenttype' },
	// 			{ label: 'Entity Type', key: 'entitytype' },
	// 			{ label: 'Filed', key: 'date_filed', formatter: 'DateFormatter' },
	// 		],
	// 	},
	// },
	deedRestrictions: {
		title: 'Deed Restrictions',
		singularTitle: 'Deed Restriction',
		dataCategory: 'certification',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Link',
					key: 'deed_lease_easement_link',
					formatter: 'OutboundLink',
				},
				{ label: 'Restriction', key: 'restriction' },
			],
		},
	},
	landmarkBuildings: {
		title: 'Landmark Buildings',
		singularTitle: 'Landmark Building',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Landmark Name', key: 'lm_new' },
				{ label: 'Building', key: 'build_nme' },
				{ label: 'Built', key: 'date_combo' },
				{ label: 'Architect/Builder', key: 'arch_build' },
				{ label: 'Owner/Developer', key: 'own_devel' },
				{ label: 'Style', key: 'style_prim' },
				{ label: 'Style (secondary)', key: 'style_sec' },
			],
		},
	},
	// landmarkSites: { //removed
	// 	title: 'Landmark Sites',
	// 	singularTitle: 'Landmark Site',
	// 	dataCategory: 'infrastructure',
	// 	[OPEN_DATA]: {
	// 		columns: [
	// 			{ label: 'Landmark Name', key: 'lpc_name' },
	// 			{ label: 'Landmark Site', key: 'lpc_sitede' },
	// 			{ label: 'Type', key: 'landmarkty' },
	// 			{ label: 'Date Designated', key: 'desdate', formatter: 'DateFormatter' },
	// 			{ label: 'Report', key: 'url_report', formatter: 'OutboundLink' },
	// 		],
	// 	},
	// },
	landmarkViolations: {
		title: 'Landmark Violations',
		singularTitle: 'Landmark Violation',
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{
					label: 'Violation Date',
					key: 'vio_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Landmark Name', key: 'landmark_name' },
				{ label: 'Violation', key: 'violation_class' },
			],
		},
	},
	landmarkApplications: {
		title: 'Landmark Applications',
		singularTitle: 'Landmark Application',
		dataCategory: 'infrastructure',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Docket', key: 'docket' },
				{ label: 'Landmark', key: 'lmnametype' },
				{ label: 'Applicant', key: 'applicant_name' },
				{ label: 'Owner', key: 'owner_name' },
				{ label: 'Worktypes', key: 'worktypes' },
				{ label: 'Regulation Type', key: 'regulation_type' },
				{ label: 'Issue Date', key: 'issue_date', formatter: 'DateFormatter' },
			],
		},
	},

	depEcbViolations: {
		title: 'DEP ECB Violations',
		singularTitle: 'DEP ECB Violations',
		dataCategory: 'violation',
		[OPEN_DATA]: {
			columns: [
				{ label: 'Ticket Number', key: 'ticket_number' },
				{
					label: 'Violation Date',
					key: 'violation_date',
					formatter: 'DateFormatter',
				},
				{ label: 'Issuing Agency', key: 'issuing_agency' },
				{
					label: 'Compliance Status',
					key: 'compliance_status',
					formatter: 'StatusBadge',
				},
				{ label: 'Violation Details', key: 'violation_details' },
			],
		},
	},
};

export default tableConfig;
